import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { GetAvailabilitiesProps, getGroupedAvailabilities } from 'src/services/api/availabilities'
import { getPractitionerReferenceIds } from 'src/utils/getPractitionerReferenceId'
import { CommonQueryParams } from './getQueryParams'
import { GetQueryKey } from './types'

type GetQueryKeyType = (commonParams: CommonQueryParams) => GetQueryKey<ReturnType<typeof getGroupedAvailabilities>>

export const getDefaultQueryParams: GetQueryKeyType = ({
  clinicReferenceId,
  treatmentBundleTypeReferenceId,
  preferredPractitionerReferenceIds,
  patientType,
  practitioners,
  patientReferenceId,
  insuranceType,
  nearbyClinics,
}) => {
  const allPractitionersSelected = practitioners?.length === preferredPractitionerReferenceIds?.length

  const queryParams: GetAvailabilitiesProps = {
    clinicReferenceId,
    treatmentBundleReferenceId: treatmentBundleTypeReferenceId,
    practitionerReferenceIds: allPractitionersSelected
      ? undefined
      : getPractitionerReferenceIds(preferredPractitionerReferenceIds),
    patientType: patientType || PatientTypeOptions.NEW,
    patientReferenceId,
    insuranceType,
    nearbyClinics,
  }

  return [['availabilities', queryParams], ({ pageParam }) => getGroupedAvailabilities(queryParams, pageParam)]
}
